import { useEffect, useState, type ReactNode } from 'react';
import { getSession, isAdminSession, onAuthStateChange, signInWithPassword, signOut, supabaseConfigured } from '@/lib/supabase';

type GateState='checking'|'signed-out'|'authorized';

export function AdminAuthGate({children}:{children:ReactNode}){
 const[state,setState]=useState<GateState>(supabaseConfigured?'checking':'authorized');
 const[email,setEmail]=useState('');
 const[password,setPassword]=useState('');
 const[error,setError]=useState('');

 const verify=async()=>{
   if(!supabaseConfigured){setState('authorized');return}
   const session=await getSession();
   if(!session?.access_token){setState('signed-out');return}
   const allowed=await isAdminSession();
   if(!allowed){await signOut();setState('signed-out');return}
   setState('authorized');
 };

 useEffect(()=>{
   if(!supabaseConfigured)return;
   void verify();
   return onAuthStateChange(()=>void verify());
 },[]);

 const login=async(e:React.FormEvent)=>{
   e.preventDefault();
   setError('');
   setState('checking');
   const{error:loginError}=await signInWithPassword(email,password);
   if(loginError){setState('signed-out');setError('הכניסה נכשלה. בדקו אימייל וסיסמה.');return}
   const allowed=await isAdminSession();
   if(!allowed){
     await signOut();
     setState('signed-out');
     setError('החשבון תקין, אך אינו מורשה להיכנס לאדמין.');
     return;
   }
   setState('authorized');
 };

 if(state==='checking')return <div className="admin-login-shell"><div className="admin-login-card"><h1>MIELLEY</h1><p>בודק הרשאת מנהל…</p></div></div>;
 if(state==='signed-out')return <div className="admin-login-shell"><form className="admin-login-card" onSubmit={login}><small>MIELLEY CONTROL CENTER</small><h1>כניסה לאדמין</h1><p>הכניסה מוגנת באמצעות Supabase Auth והרשאת מנהל ייעודית.</p><label>אימייל<input type="email" required value={email} onChange={e=>setEmail(e.target.value)}/></label><label>סיסמה<input type="password" required value={password} onChange={e=>setPassword(e.target.value)}/></label>{error&&<div className="admin-error">{error}</div>}<button className="btn dark full">כניסה</button></form></div>;
 return <>{children}</>;
}
